import Swiper, {
  Navigation,
  Pagination,
  Keyboard,
  EffectFade,
  Controller,
  Scrollbar,
  Autoplay,
  A11y,
  Mousewheel,
} from "swiper";

export default class SwiperCarousel {
  constructor(target, data) {
    this.target = target;
    this.data = data;
    this.swiper = null;
    this.createSlider();
  }

  updateController(control) {
    if (this.swiper && this.swiper.controller) {
      this.swiper.controller.control = control;
    } else {
      // eslint-disable-next-line no-console
      console.error("Swiper instance or controller is not initialized");
    }
  }

  createSlider() {
    if (this.target && this.data) {
      try {
        this.swiper = new Swiper(this.target, {
          modules: [
            Navigation,
            Pagination,
            EffectFade,
            Controller,
            Scrollbar,
            Autoplay,
            Keyboard,
            A11y,
            Mousewheel,
          ],
          ...this.data,
        });
      } catch (error) {
        console.error("Failed to initialize SwiperCarousel:", error);
        return null;
      }
    } else {
      // eslint-disable-next-line no-console
      console.error("No target element or settings provided to SwiperCarousel");
      return null;
    }

    return this.swiper;
  }
}
